// apps/web/src/components/InstagramLink.tsx
import { Instagram } from 'lucide-react';
import { normalizeInstagramHandle, isValidInstagramHandle, instagramUrl } from '@/domain/instagram';

/** Clickable @handle → profile (new tab). Renders nothing when the handle is
 *  missing/invalid, so callers can drop it in unconditionally. */
export default function InstagramLink({ handle, className }: { handle?: string; className?: string }) {
  const h = normalizeInstagramHandle(handle ?? '');
  if (!isValidInstagramHandle(h)) return null;
  return (
    <a
      href={instagramUrl(h)}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-gold-bright hover:underline ${className ?? ''}`}
      data-testid="instagram-link"
    >
      <Instagram size={12} />@{h}
    </a>
  );
}
